// extracted by mini-css-extract-plugin
module.exports = {"content":"_13fBdb","inactive":"_2QWoCD","text":"HjYJmV","count":"_1tGfYS"};